// Nutrients.js — 영양소 표기 통일 (라벨·단위·색)
import React from 'react';
import './ui.css';

export const NUTRIENTS = [
  { key: 'kcal', label: '칼로리', unit: 'kcal' },
  { key: 'carbo', label: '탄수', unit: 'g', color: 'var(--carbo)' },
  { key: 'protein', label: '단백', unit: 'g', color: 'var(--protein)' },
  { key: 'fat', label: '지방', unit: 'g', color: 'var(--fat)' },
  { key: 'sugar', label: '당', unit: 'g' },
  { key: 'dietFiber', label: '식이섬유', unit: 'g' },
];

export const MACROS = NUTRIENTS.filter((n) => n.color);

export const fmt = (v, digits = 0) => {
  const n = Number(v) || 0;
  return n.toLocaleString('ko-KR', { maximumFractionDigits: digits });
};

// 목표 대비 막대 한 줄: 탄수 ████░░ 145 / 275g
export function NutrientBar({ label, color, value, goal, unit = 'g' }) {
  const ratio = goal > 0 ? Math.min(value / goal, 1) : 0;
  return (
    <div className="nbar">
      <span className="nbar-name"><span className="nbar-dot" style={{ background: color }} />{label}</span>
      <div className="nbar-track"><span style={{ width: `${ratio * 100}%`, background: color }} /></div>
      <span className="nbar-num">{fmt(value)}<small> / {fmt(goal)}{unit}</small></span>
    </div>
  );
}

// 탄단지 칼로리 비율 띠
export function MacroStrip({ carbo = 0, protein = 0, fat = 0 }) {
  const c = carbo * 4; const p = protein * 4; const f = fat * 9;
  const t = c + p + f || 1;
  return (
    <div className="macro-strip" title="탄·단·지 비율">
      <span style={{ flex: c / t, background: 'var(--carbo)' }} />
      <span style={{ flex: p / t, background: 'var(--protein)' }} />
      <span style={{ flex: f / t, background: 'var(--fat)' }} />
    </div>
  );
}

// 탄 12g · 단 8g · 지 3g
export function MacroText({ carbo, protein, fat }) {
  return (
    <span className="macro-text">
      <span style={{ color: 'var(--carbo)' }}>탄 {fmt(carbo, 1)}g</span>
      <span style={{ color: 'var(--protein)' }}>단 {fmt(protein, 1)}g</span>
      <span style={{ color: 'var(--fat)' }}>지 {fmt(fat, 1)}g</span>
    </span>
  );
}
